export default {'language.title':'Langue','language.en-US':'Anglais','language.en-GB':'Anglais','language.fr-FR':'Française','language.zn-CH':'Chinoise'}